import { render } from "./PreviewImagesVideo.vue?vue&type=template&id=1ad08f3c&scoped=true"
import script from "./PreviewImagesVideo.vue?vue&type=script&lang=js"
export * from "./PreviewImagesVideo.vue?vue&type=script&lang=js"

import "./PreviewImagesVideo.vue?vue&type=style&index=0&id=1ad08f3c&scoped=true&lang=css"
import "@/modules/shared/views/orders/order-detail/style.scss?vue&type=style&index=1&id=1ad08f3c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ad08f3c"]])

export default __exports__